import useSWR from 'swr';

import { ENDPOINTS } from '@/api/endpoints';
import { getCameras } from '@/api/cameras';

export const useGetCamerasFullList = () => {
  const {
    data: cams,
    isLoading,
    mutate: getCams,
  } = useSWR([ENDPOINTS.CAMERAS], () => getCameras(), {
    revalidateOnFocus: false,
  });

  return {
    cams,
    loading: isLoading,
    refetchCatalog: getCams,
  };
};
